"use client";

import { useId } from "react";

import { HONEYPOT_FIELD } from "@/lib/form-fields";

/**
 * A visually hidden "honeypot" input. Real visitors never see or fill it, so any
 * submission that arrives with a value here was almost certainly a bot. Kept off
 * screen (rather than `display:none`) and out of the tab order, with autofill
 * switched off so password managers leave it alone.
 *
 * Pair with the time trap: forms also send how long they were on screen via the
 * `form_elapsed_ms` field (see `@/lib/form-fields`). The server checks both.
 */
export function HoneypotField() {
  const id = useId();
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute -left-[9999px] top-auto h-0 w-0 overflow-hidden"
    >
      <label htmlFor={id}>Leave this field blank</label>
      <input
        id={id}
        type="text"
        name={HONEYPOT_FIELD}
        tabIndex={-1}
        autoComplete="off"
        defaultValue=""
      />
    </div>
  );
}
